import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  deleteCountingUnique: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/live/counting/unique`,
  },
  deleteCountingUniqueNewKafka: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/${configs.LiveProxyRootPath}/counting/unique`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const deleteCountingUnique = async (payload) => {
  return resource.deleteCountingUnique({}, payload)
}

export default {
  initResource,
  deleteCountingUnique,
}
